import {
  EnumContentType,
  EnumSearchStudyProgress,
  EnumSearchStudyWay,
  EnumSearchOrderType,
  EnumSearchProductType
} from '@xt/client/enums/product'

export const searchLearnTimeYear = [
  { label: '全部', value: '', selectionLabel: '开课时间' },
  { label: '2026', value: '2026', selectionLabel: '2026' },
  { label: '2025', value: '2025', selectionLabel: '2025' },
  { label: '2024', value: '2024', selectionLabel: '2024' },
  { label: '2023', value: '2023', selectionLabel: '2023' },
  { label: '2022', value: '2022', selectionLabel: '2022' },
  { label: '2021', value: '2021', selectionLabel: '2021' },
  { label: '2020', value: '2020', selectionLabel: '2020' },
  { label: '2019', value: '2019', selectionLabel: '2019' },
  { label: '2018', value: '2018', selectionLabel: '2018' }
]

export const searchContentType = [
  { label: '全部', value: '' },
  { label: '书法', value: EnumContentType.Calligraphy },
  { label: '国画', value: EnumContentType.Painting },
  { label: '书画', value: EnumContentType.CalligraphyAndReading },
  { label: '美育', value: EnumContentType.AestheticEducation }
]

export const searchStudyProgress = [
  { label: '全部', value: '', selectionLabel: '课程进度' },
  { label: '未开始', value: EnumSearchStudyProgress.NotStart, selectionLabel: '未开始' },
  { label: '报名中', value: EnumSearchStudyProgress.Registering, selectionLabel: '报名中' },
  { label: '开课中', value: EnumSearchStudyProgress.InProgress, selectionLabel: '开课中' },
  { label: '已结课', value: EnumSearchStudyProgress.End, selectionLabel: '已结课' }
]

export const searchStudyWay = [
  { label: '全部', value: '', selectionLabel: '学习方式' },
  { label: '直播', value: EnumSearchStudyWay.Live, selectionLabel: '直播' },
  { label: '打卡', value: EnumSearchStudyWay.CheckIn, selectionLabel: '打卡' },
  { label: '闯关', value: EnumSearchStudyWay.Breakthrough, selectionLabel: '闯关' }
]

export const searchOrderType = [
  { label: '推荐', value: EnumSearchOrderType.New },
  { label: '最新', value: EnumSearchOrderType.Default }
]

export const searchProductType = [
  { label: '全部', value: '' },
  { label: '系列课', value: EnumSearchProductType.Series },
  { label: '专题课', value: EnumSearchProductType.SpecialTopic },
  { label: '教练日课', value: EnumSearchProductType.DayCourse },
  { label: '自习课', value: EnumSearchProductType.SelfStudy },
  { label: '暄桐展览', value: EnumSearchProductType.StudyExhibition }
]
